import Carousel from '@/common/helios/Carousel/Carousel';
import { CarouselSkeleton } from '@/home/SkeletonLoaders';
import { SecondaryAnchorButton } from '~/components/common/helios/AnchorButton';
import TagIds from '~/constants/common/tagIds';
import { useDeviceType } from '~/context/common/DeviceContext';
import { DeviceType } from '~/contracts/common';
import useGetVehicles from '~/hooks/ev-tax-credit/useGetVehicles';
import useCarouselSettings from '~/hooks/home/useCarouselSettings';
import { EvCarouselSection } from './EvCarousel.styles';
import generateEvTaxCreditLink from '../utils/generateEvTaxCreditLink';
import VehicleTile from '../VehicleTile/VehicleTile';
import VehicleTileSkeleton from '../VehicleTile/VehicleTileSkeleton';

const EvAndPriceFilters = {
  tagIds: [String(TagIds.EvTaxCreditMayBeEligible)],
  price: { max: 25000 }
};

const getCarouselWidthGap = ({ isDesktop, isTablet }: DeviceType): number => {
  if (isDesktop) {
    return 324;
  } else if (isTablet) {
    return 243;
  } else {
    return 312;
  }
};

export default function EvCarousel() {
  const { vehicles, isLoading, isLoaded, error } = useGetVehicles(
    EvAndPriceFilters,
    true
  );
  const widthGap = getCarouselWidthGap(useDeviceType());
  const { values, carouselRef } = useCarouselSettings({
    heading: 'Eligible EVs under $25k',
    subHeading: 'Discover great deals on eligible electric vehicles',
    maxLength: vehicles.length,
    widthGap
  });

  if (isLoading)
    return (
      <EvCarouselSection>
        <CarouselSkeleton includeSubHeader Tile={VehicleTileSkeleton} />
      </EvCarouselSection>
    );

  if (isLoaded && (vehicles?.length < 4 || error)) return null;

  return (
    <EvCarouselSection>
      <Carousel {...values} ref={carouselRef}>
        {vehicles.map(vehicle => {
          const { vehicleId } = vehicle;

          return (
            <a
              href={`/vehicle/${vehicleId}`}
              key={vehicleId}
              data-analytics-id="Ev Tile Click"
              className="inline-block !w-fit no-underline"
              data-analytics-attributes={JSON.stringify({ vehicleId })}
            >
              <VehicleTile {...vehicle} />
            </a>
          );
        })}
      </Carousel>
      <div className="flex w-full items-center">
        <SecondaryAnchorButton
          href={generateEvTaxCreditLink()}
          size="lg"
          className="mx-auto mt-5xl w-full sm:w-fit"
          data-analytics-id="EvCarousel - See More"
        >
          See More
        </SecondaryAnchorButton>
      </div>
    </EvCarouselSection>
  );
}
